/* Board 6 lane B6F: the collection page. Loaded deferred by sections/main-collection-products.liquid (after
   custom-pagination.js) only while umbra_plp_compact (L1) or umbra_plp_more (L2) is on. Each part looks for its own
   hook and does nothing without it.
   L1: the facet dropdown pills (one open at a time, Esc and a click outside close them, a pick goes through the drawer's
       own AJAX path); after every filter update the pills are copied back from the template inside #filter-results, the
       title count follows, and on phones the applied-filter chips ride in the sticky Filter & sort bar.
   L2: Show more keeps the address; the number of pages loaded and the scroll position live in history.state, so Back
       (or a reload) loads the same pages again under the beam and returns to the same place. */
(function () {
  var W = window,
    D = document,
    H = W.history,
    K = 'ub6f';

  function ff() {
    var el = D.querySelector('facet-filters');
    return el && typeof el.applyFilters === 'function' ? el : null;
  }

  function plainClick(e) {
    return !(e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.defaultPrevented);
  }

  /* ---- L1 ---------------------------------------------------------------------------------------------------- */

  /* B6V-2: .ub6v-tb is today's toolbar with the same pills (umbra_plp_facet_pills); the chip move below stays L1's */
  var tb = D.querySelector('.ub6f-tb, .ub6v-tb');

  function closeAll(except) {
    D.querySelectorAll('.ub6f-dd[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  function apply(href, e) {
    var f = ff();
    if (!f) return false;
    e.preventDefault();
    closeAll();
    f.applyFilters(new URL(href, W.location.href).searchParams.toString(), e);
    return true;
  }

  if (tb) {
    D.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.classList || !d.classList.contains('ub6f-dd') || !d.open) return;
      closeAll(d);
      d.classList.remove('is-end');
      var p = d.querySelector('.ub6f-dd__panel');
      if (p && p.getBoundingClientRect().right > D.documentElement.clientWidth - 8) d.classList.add('is-end');
    }, true);

    D.addEventListener('click', function (e) {
      var open = D.querySelector('.ub6f-dd[open]');
      if (open && !open.contains(e.target)) open.removeAttribute('open');
      var a = e.target.closest && e.target.closest('a[data-ub6f-link], .ub6f-tb > .umbra-chips a[data-umbra-chip]');
      if (a && plainClick(e)) apply(a.href, e);
    });

    D.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = D.querySelector('.ub6f-dd[open]');
      if (!open) return;
      open.removeAttribute('open');
      var s = open.querySelector('summary');
      if (s) s.focus();
    });

    D.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-ub6f-price]')) return;
      var f = ff();
      if (!f) return;
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        if (String(v).trim() !== '') params.append(k, v);
      });
      closeAll();
      f.applyFilters(params.toString(), e);
    });
  }

  var mq = W.matchMedia('(max-width: 769.98px)');

  function placeChips(updated) {
    var box = D.querySelector('.ub6f-tb.products-toolbar-box--stick-sm'),
      res = D.getElementById('filter-results');
    if (!box || !res) return;
    var fresh = res.querySelector('.umbra-chips'),
      moved = box.querySelector(':scope > .umbra-chips');
    if (mq.matches) {
      if (fresh) {
        if (moved) moved.remove();
        box.appendChild(fresh);
      } else if (moved && updated) {
        moved.remove();
      }
    } else if (moved) {
      res.insertBefore(moved, res.querySelector(':scope > ul, :scope > p'));
    }
  }

  function syncPills() {
    var src = D.querySelector('#filter-results template[data-ub6f-dd-src]'),
      cur = D.querySelector('.products-toolbar [data-ub6f-dd]');
    if (!src) return;
    var next = src.content.querySelector('[data-ub6f-dd]');
    if (cur && next) {
      cur.replaceWith(next.cloneNode(true));
    } else if (cur) {
      cur.remove();
    } else if (next) {
      var btn = D.querySelector('.ub6f-tb .products-toolbar__filter-btn, .ub6v-tb .products-toolbar__filter-btn');
      if (btn) btn.after(next.cloneNode(true));
    }
  }

  function syncCount() {
    var el = D.querySelector('[data-ub6f-count]'),
      btn = D.querySelector('.facets .js-close-drawer-mob'),
      m = btn && btn.textContent.match(/\d[\d,]*/);
    if (!el || !m) return;
    var n = el.querySelector('[aria-hidden]'),
      label = el.querySelector('.visually-hidden');
    if (n) n.textContent = m[0];
    if (label && el.dataset.countOther) label.textContent = m[0] === '1' ? el.dataset.countOne : el.dataset.countOther.replace('[n]', m[0]);
  }

  if (tb) {
    placeChips(false);
    if (mq.addEventListener) mq.addEventListener('change', function () { placeChips(false); });
  }

  D.addEventListener('on:facet-filters:updated', function () {
    if (tb) {
      syncPills();
      placeChips(true);
    }
    syncCount();
  });

  /* ---- L2 ---------------------------------------------------------------------------------------------------- */

  var cp = D.querySelector('custom-pagination[data-ub6f-more]');
  if (!cp) return;

  var n = 1,
    restoring = false;

  function state() {
    var s = H.state;
    return s && typeof s === 'object' ? s : {};
  }

  function save(patch) {
    try {
      var s = Object.assign({}, state());
      /* facet-filters.js reads searchParams on popstate; an entry it did not push still needs its own */
      if (!('searchParams' in s)) s.searchParams = W.location.search.slice(1);
      s[K] = Object.assign({}, s[K], patch);
      H.replaceState(s, '');
    } catch (err) {
      /* a blocked history write leaves Back as the browser does it */
    }
  }

  function manual() {
    try {
      if ('scrollRestoration' in H) H.scrollRestoration = 'manual';
    } catch (err) {
      /* ignore */
    }
  }

  function remember() {
    if (n > 1 && !restoring) save({ n: n, y: Math.round(W.scrollY) });
  }

  cp.addEventListener('on:pagination:loaded', function () {
    n += 1;
    if (restoring) return;
    manual();
    save({ n: n, y: Math.round(W.scrollY) });
  });

  D.addEventListener('on:facet-filters:updated', function () {
    n = 1;
    if (state()[K]) save({ n: 1, y: 0 });
  });

  cp.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href]')) remember();
  }, true);
  W.addEventListener('pagehide', remember);
  D.addEventListener('visibilitychange', function () {
    if (D.visibilityState === 'hidden') remember();
  });

  var saved = state()[K];
  if (!saved || !(saved.n > 1)) return;

  restoring = true;
  manual();
  var userMoved = false,
    stop = function () { userMoved = true; };
  W.addEventListener('wheel', stop, { passive: true, once: true });
  W.addEventListener('touchstart', stop, { passive: true, once: true });
  W.addEventListener('keydown', stop, { once: true });

  /* the wait is shown: the beam, fixed at the foot of the screen, until the pages are back */
  var beam = D.createElement('span');
  beam.className = 'umbra-beam umbra-beam--standalone ub6f-restore';
  beam.setAttribute('role', 'status');
  beam.setAttribute('aria-label', cp.dataset.ub6fLoading || 'Loading');
  beam.style.setProperty('--umbra-beam-color', '21 21 23');
  D.body.appendChild(beam);

  (async function () {
    try {
      for (var i = 1; i < saved.n; i += 1) {
        if (!cp.querySelector('.js-pagination-load-more')) break;
        var before = cp.querySelectorAll('.js-pagination-result').length;
        await cp.loadMore();
        if (cp.querySelectorAll('.js-pagination-result').length === before) break;
      }
    } catch (err) {
      /* whatever loaded stays; the visitor can press Show more */
    }
    restoring = false;
    beam.remove();
    save({ n: n });
    if (userMoved) return;
    W.requestAnimationFrame(function () {
      W.requestAnimationFrame(function () {
        W.scrollTo(0, saved.y || 0);
      });
    });
  })();
})();
